export class Explotacion {
    Codigo: string;
    Descripcion: string;
    Domicilio: string;
    Contacto: string;
    Horario: string;
    Sociedad: string;
    Email: string;
    CondicionesEnvio: string;
    PoliticaEnvio: string;
    CadenaPagoOVE: string;
    PermitirPagosOVE: boolean;
}
